import { SubFsmBuilder } from "little-fsm";
import { PaymentSelectionFsmContext } from "./PaymentSelectionFsmContext";

import Either from "../../types/Either";
import { ErrorDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO } from "../../apiclient/ApiDtos";

export type PaymentSelectionFsmScheme = {
    context: PaymentSelectionFsmContext,
    substates: [
        'initial',
        'fetching_payment_methods',
        'showing_payment_options',
        'showing_selected_payment',
        'viewing_payment_terms',
        'confirming_tentative_booking_lost',
        "applying_promo_code",
        "showing_already_paid_alert"

    ],
    events: {
        'back': {},
        'back_confirmed': {},
        'back_cancelled': {},
        'requested_payment_options': {},
        "fetching_payments_succeed": { paymentOptions: PaymentOptionDTO[] },
        "fetching_payments_failed": { errorMessage: string },
        "payment_selected": { paymentOption: PaymentOptionDTO },
        "selected_payment_closed": {},
        "payment_terms_opened": {},
        "payment_terms_closed": {},
        "promo_code_added": { promoCode: string },
        "promo_removed": {},
        "promo_verification_finished": { result: Either<ErrorDTO, PromoCodeVerifiedResponseDTO> },
        "duplicate_payment_attempted": {},
        'force_back_to_home': {},
    }
}

// just simple identity function
const $I = (x) => x;

export function paymentSelectionSubFsmBuilder(): SubFsmBuilder<PaymentSelectionFsmScheme> {
    let subBuilder = new SubFsmBuilder<PaymentSelectionFsmScheme>();

    subBuilder.entrySubstate("initial")

    subBuilder.substate("initial")
        .transition('requested_payment_options', 'fetching_payment_methods', (c, e) => c)

    subBuilder.substate("fetching_payment_methods")
        .transition('fetching_payments_succeed', 'showing_payment_options',
            (context, event) => context.withPaymentOptions(event.paymentOptions))
        .transition("back", "confirming_tentative_booking_lost", (c, e) => c)

    subBuilder.substate("showing_payment_options")
        .transition('payment_selected', 'showing_selected_payment',
            (context, event) => context.withSelectedPaymentOption(event.paymentOption))
        .transition("back", "confirming_tentative_booking_lost", (c, e) => c)


    subBuilder.substate("confirming_tentative_booking_lost")
        .transition('back_cancelled', 'showing_payment_options', $I)
        .termination('back_confirmed', $I)

    subBuilder.substate("showing_selected_payment")
        .transition('selected_payment_closed', 'showing_payment_options',
            (context, event) => context.withoutSelectedPayment())
        .transition('promo_code_added', 'applying_promo_code',
            (context, event) => context.withVerifyingPromoCode(event.promoCode))
        .transition('promo_removed', 'showing_selected_payment',
            (context, event) => context.withoutPromo())
        .transition('back', 'showing_payment_options',
            (context, event) => context.withoutSelectedPayment())
        /* .transition('duplicate_payment_attempted', 'showing_already_paid_alert', 
            (c, e) => c) */
        .completion("duplicate_payment_attempted", (c, e) => c)

    subBuilder.substate("applying_promo_code")
        .transition('promo_verification_finished', 'showing_selected_payment',
            (context, event) => context.withVerifiedPromoResult(
                event.result
            ))


    subBuilder.substate("showing_already_paid_alert")
        .termination('back', $I)

    return subBuilder;
}


